import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { ClaimStore } from './claim.store';

@Injectable({
    providedIn: 'root'
})
export class ClaimQuery extends BaseQuery {

    constructor(store: ClaimStore) {
        super(store);
    }


}
